import axios from "axios";
const API_URL = "/api/user";
const userRegister = async (userDetails) => {
   const response = await axios.post("/api/user/register", userDetails);
   return response.data;
};

const userLogin = async (userDetails) => {
  try {
    const API_URL = `/api/${
      userDetails.role === "student" ? "user" : userDetails.role
    }/login`;
    const response = await axios.post(API_URL, userDetails);
    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
      if (response.data.showIntroVideo) {
        localStorage.setItem("showLoginVideo", "true");
      } else {
        localStorage.removeItem("showLoginVideo");
      }
    }
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.data.message ||
        "Login failed. Please try again"
    );
  }
};

const userLogout = async (token) => {
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.delete("/api/user/loggout", options);
    if (res.status === 200) {
      localStorage.removeItem("user");
    }
  } catch (error) {
    console.error("Error logging out:", error.response?.data || error.message);
  }
};

const userServices = {
  userRegister,
  userLogin,
  userLogout,
};

export default userServices;
